import React from 'react';

import Image from '../../../../library/image/image';
import Tooltip from '../../../../library/tooltip/tooltip';
import Typography from '../../../../library/typography/typography';
import ProductWarranty from '../../../../components/product-warranty/product-warranty';
import TireAttributeIcon from '../../../../components/tire-attribute-icons/components/tire-attribute-icon/tire-attribute-icon';

import { useContainerQuery } from '../../../../shared/hooks/hooks';

import { TIRE_ATTRIBUTE_ICON_DESCRIPTION } from '../../../../shared/constants/products';

import styles from './pdp-feature-icons.scss';

interface PdpFeatureIconsInterface {
  hideWarranty?: boolean;
  icons: string[];
  rollingResistanceRating?: number | null;
  warranty?: string | null;
}

function PdpFeatureIcons(props: PdpFeatureIconsInterface) {
  const { hideWarranty, icons, rollingResistanceRating, warranty } = props;

  const breakpoint = useContainerQuery();

  if (!(Array.isArray(icons) && icons.length > 0)) {
    return null;
  }
  return (
    <>
      {breakpoint.isMinSm && (
        <Typography
          className={styles['icons-header']}
          tag="span"
          variant="H6"
          weight="black"
        >
          Features
        </Typography>
      )}
      {icons.map((icon, i) => {
        if (!TIRE_ATTRIBUTE_ICON_DESCRIPTION[icon]) return null;
        return (
          <div className={styles['icon-container']} key={i}>
            <TireAttributeIcon className={styles['icon']} name={icon} />
            <Typography className={styles['icon-description']} tag="span">
              {TIRE_ATTRIBUTE_ICON_DESCRIPTION[icon].description}
            </Typography>
          </div>
        );
      })}
      {warranty && !hideWarranty && (
        <div className={styles['icon-container']}>
          <TireAttributeIcon className={styles['icon']} name="touring" />
          <ProductWarranty
            className={styles['icon-description']}
            miles={warranty}
          />
        </div>
      )}
      {Number(rollingResistanceRating) >= 4 && (
        <div className={styles['icon-container']}>
          <Image
            alt="Fuel Efficiency Logo"
            className={styles['icon-fuel-efficiency']}
            height="22"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/treadwell-gray-tire-leaf.svg"
            width="22"
          />
          <Typography className={styles['icon-description']} tag="span">
            Fuel Efficient
          </Typography>
          <Tooltip
            className={styles['tooltip-fuel-efficiency']}
            content="Efficiency refers to the energy needed to spin a tire. Tires with low rolling resistance are more efficient, providing you with more MPGs or MPGes."
          />
        </div>
      )}
    </>
  );
}

export default PdpFeatureIcons;
